import Context from 'widget/contexts/Analytics/AnalyticsContext';
import Provider from 'widget/contexts/Analytics/AnalyticsProvider';

export default {
  Consumer: Context.Consumer,
  Context,
  Provider,
};
